import { createNamespace } from '../utils'; // component

import Icon from '../icon';

var _createNamespace = createNamespace('dot'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

export default createComponent({
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      default: 'common'
    },
    num: String || Number,
    value: String,
    dotClass: String
  },
  data: function data() {
    return {};
  },
  methods: {
    renderNumComponents: function renderNumComponents(num) {
      var h = this.$createElement;
      if (num > 99) return h("div", {
        "class": bem('num__max')
      }, [h(Icon, {
        "attrs": {
          "name": "cap-ellipsis",
          "size": "12"
        }
      })]);
      if (num >= 10) return h("div", {
        "class": bem('num__mid')
      }, [num]);
      if (num >= 1) return h("div", {
        "class": bem('num__min')
      }, [num]);
    },
    renderTextComponents: function renderTextComponents(value) {
      var h = this.$createElement;

      if (value && value.length === 1) {
        return h("div", {
          "class": bem('text__min')
        }, [value]);
      }

      return h("div", {
        "class": bem('text')
      }, [value]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var type = this.type,
        num = this.num,
        dotClass = this.dotClass,
        value = this.value;

    if (type === 'num') {
      // 数字角标组件
      return h("div", {
        "class": [bem('dot'), dotClass]
      }, [this.renderNumComponents(num)]);
    }

    if (value) {
      // 中文标签
      return h("div", {
        "class": [bem('dot'), dotClass]
      }, [this.renderTextComponents(value)]);
    }

    return h("div", {
      "class": [bem('dot'), dotClass]
    }, [h("div", {
      "class": bem('default')
    }, [num])]);
  }
});